<div class="promo-banner" *ngIf="banner?.show" [style.backgroundColor]="banner?.backgroundColor">
    <p [style.color]="banner?.textColor">
        {{banner?.text}} 
        <a [href]="banner?.link">{{banner?.linkText}}</a>
        <button type="button" class="button-close" (click)="closeBanner()" *ngIf="banner?.showCloseButton"></button>
    </p>
</div>